import {TechnicalIssueStatus} from '@services/TechnicalSupport/types';
import {defaultTableConfig} from '@ui/NewTable/constants';
import {ColumnFormats, ColumnRecord, ColumnTypes, TableConfig} from '@ui/NewTable/types';

export const checkhStatusDisabled = (
    status: TechnicalIssueStatus,
    issueStatus: TechnicalIssueStatus,
) => {
    if (status === issueStatus) return true;
    if (status === TechnicalIssueStatus.OPEN) return true;
    if (issueStatus === TechnicalIssueStatus.COMPLETED) return true;
    return false;
};

export const technicalSupportIssueStatusHistoryTableConfig: TableConfig = defaultTableConfig;

export const technicalSupportIssueStatusHistoryColumns: ColumnRecord = {
    status: {
        id: 'status',
        type: ColumnTypes.STRING,
        title: 'status.title',
        enumDict: true,
        dictName: 'SupportTicketStatus',
    },
    date: {
        id: 'date',
        type: ColumnTypes.STRING,
        title: 'technicalSupport.changeDate',
        format: ColumnFormats.DATE_TIME,
    },
    username: {
        id: 'username',
        type: ColumnTypes.STRING,
        title: 'technicalSupport.username',
    },
};
